export default __webpack_public_path__ + "static/Login-858cc8cb04f3ffcbdc7bdc16f16d1f9c.jpg";